﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'
import { appendContent, openOverlay } from '../../_Shared/Scripts/MyAimoParkOverlay'
import { seasonTickets } from './Endpoints'

function myAimoParkSeasonTicketsPage(context) {
  const htmlElement = document.querySelector('html');
  const overlayContext = document.querySelector("[data-controller=myaimopark-overlay]");
  const endpointSettings = context.dataset.endpointUrl ? { PermitPageUrl: context.dataset.endpointUrl } : {}

  function init() {
    const closeDropDowns = (event, closeAll) => {
      const openDropDowns = Array.prototype.slice.call(document.querySelectorAll('.open'));
      if (openDropDowns) {
        openDropDowns.forEach(element => {
          if (closeAll || (element != event.target && !event.target.classList.contains('valuelist') && !event.target.parentElement.classList.contains('valuelist'))) element.classList.remove('open');
        });
      };
    };

    window.addEventListener('blur', function (event) {
      closeDropDowns(event, true);
    });

    context.addEventListener('click', async function (event) {
      closeDropDowns(event);
      if (event.target.dataset.permitId) {
        event.preventDefault();

        const heading = event.target.dataset.heading;
        const subHeading = event.target.dataset.subHeading;
        const permitId = event.target.dataset.permitId;

        //Open season ticket overlay
        openPermitOverlay(heading, subHeading, permitId);

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('permitId', permitId);

        const newUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
        history.replaceState(paramsToObject(urlParams), document.title, newUrl);
      } else if (event.target.getAttribute('aria-haspopup')) {
        const list = event.target.nextElementSibling;
        const middleContainerHeight = event.target.closest('.middle').getBoundingClientRect().height;;
        const notFirefox = navigator.userAgent.indexOf("Firefox") != -1 ? 0 : 0.5;

        list.removeAttribute('style');
        list.style.top = middleContainerHeight + notFirefox + 12 + 'px';

        event.target.classList.toggle('open');
      }
    });

    //If url contains permiId paramater - show overlay
    const permitIdQuery = new URLSearchParams(window.location.search).get('permitId');

    if (permitIdQuery) {
      const permitListItem = context.querySelector(`.myaimoparkseasontickets__list li a[data-permit-id="${permitIdQuery}"]`);

      if (permitListItem) {
        const heading = permitListItem.dataset.heading;
        const subHeading = permitListItem.dataset.subHeading;
        const permitId = permitListItem.dataset.permitId;

        //Open permit overlay
        openPermitOverlay(heading, subHeading, permitId);
      }
    }
  }

  async function openPermitOverlay(heading, subHeading, permitId) {
    openOverlay(overlayContext, { heading, subHeading, clearContent: true });

    const getSeasonTicketInformation = await seasonTickets.getSeasonTicketInformation({ ...endpointSettings, PermitId: permitId }).catch((err) => err);

    if (getSeasonTicketInformation.status === 200) {
      if(htmlElement.classList.contains('map-overlay-active')) {
        appendContent(overlayContext, null, getSeasonTicketInformation.body);
      }
    }
    // else {
    //   appendContent(overlayContext, { error: true });
    // }
  }

  return {
    init
  };
}

controller.add('myaimopark-season-tickets-page', myAimoParkSeasonTicketsPage);